import React from 'react'
import { render } from 'react-dom'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import Helpers from '../Helpers/Custom';



function Bar(props) {
    const options = {
        plotOptions: {
            column: {
                // stacking: 'normal',
                dataLabels: {
                    enabled: true,
                    formatter: function() {
                      return this.y+"%";
                    }  
                }
              }
        },
        colors:props.colors || ['#194f90'],
        chart: {
            type:props.type || 'bar'
        },
        title: {
          text: props.title
        }, 
        xAxis: {
            categories: props.categories,
            title: {
                text: null
            }
        },
        tooltip: {
            formatter: function() {
                return '<b>'+ this.y+"%" +'</b>';
            }
        },
        yAxis: {
           // min: 0,
            title: {
                text: props.text ||  'Millions',
            },
            //opposite: true
            // stackLabels: {
            //     enabled: true
            //   }
            // labels: {
            //     overflow: 'justify'
            // }
        },
        series: [{
            showInLegend: false,    
            // minPointSize: 10,
            // zMin: 0,
            data: props.data
        }],
        
      }


   
    //   Highcharts.setOptions({
    //     colors: ['#194f90']
    // });
    return (
        <div>
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
            />
        </div>
    )
}

export default Bar
